<app-button-setup-four *ngIf="type === 'agreement'"> </app-button-setup-four>
<app-button-setup-two
  *ngIf="type !== 'agreement' && !readingMode"
  [type] = "type"
></app-button-setup-two>
<app-button-setup-one *ngIf="readingMode"></app-button-setup-one>
